import { Box, Typography } from "@jewlr/storybook/core"
import PropTypes from "prop-types"
import React from "react"
import { Link } from "react-router-dom"

import Image from "components/landing/image"
import StyledLink from "components/landing/link"

const WatchCollections = ({ data }) => (
  <Box
    alignItems="center"
    bg="polar"
    mb={{ _: 4, tablet: 6 }}
    py={5}
    textAlign="center"
  >
    <Typography fontSize={25} lineHeight={1} mb={2} px={{ _: 7, tablet: 0 }}>
      Discover Our Watch Collections
    </Typography>
    <Typography>
      Unique styles with a choice of custom
      <br /> options – crafted just for you.
    </Typography>
    <Box contain display={{ _: "block", tablet: "flex" }}>
      {data.map((collection, index) => (
        <Box
          flex="1"
          key={`${collection.title}-${index}`}
          mb={{ _: 2, tablet: 0 }}
        >
          <Link data-lc="watch-collections" to={collection.links.url}>
            <Image image={collection.image} />
          </Link>
          <StyledLink
            style={collection.links.style}
            type={collection.links.base_style}
            url={collection.links.url}
            {...collection.links}
          >
            {collection.links.text}
          </StyledLink>
        </Box>
      ))}
    </Box>
  </Box>
)

WatchCollections.propTypes = {
  data: PropTypes.array,
  descriptionOnTop: PropTypes.bool,
}
export default WatchCollections
